import {
  Component,
  ChangeDetectionStrategy,
  Input, OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Link } from '@models/cms/link.model';
import {
  SafeHtmlPipe,
  SanitizerValueType,
} from '@pipes/safe-html/safe-html.pipe';
import { BrowserService } from '@services/browser/browser.service';

@Component({
  selector: 'app-link-display',
  standalone: true,
  imports: [RouterModule, CommonModule, SafeHtmlPipe],
  templateUrl: './link-display.component.html',
  styleUrls: ['./link-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkDisplayComponent implements OnChanges {
  @Input() linkItem: Link | undefined;
  @Input() class: string | undefined;
  @Input() newTab: boolean;

  @Output() linkClicked: EventEmitter<Event> = new EventEmitter<Event>();

  readonly SanitizerValueType = SanitizerValueType;

  target: string;
  startsWithSlash = false;
  isLinkMailTo = false;

  constructor(
    private browserService: BrowserService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.linkItem && changes.linkItem.currentValue) {
      this.target =
        this.linkItem?.external || this.linkItem?.pdf?.url || !!this.newTab
          ? '_blank'
          : '_self';
      this.startsWithSlash = this.linkItem?.link?.startsWith('/') ?? false;
      this.isLinkMailTo = this.linkItem?.link?.startsWith('mailto') ?? false;
    }
  }

  async onLinkClicked(event: Event): Promise<void> {
    let a: HTMLAnchorElement | HTMLSpanElement = event.target as HTMLAnchorElement;

    if (a instanceof HTMLSpanElement) {
      a = a.parentElement as HTMLAnchorElement;
    }

    event.stopPropagation();
    event.preventDefault();
    if (a instanceof HTMLAnchorElement && a.href === 'https://openchat/') {
      window.kindlyChat.openChat();
      return;
    }

    if (this.target == '_blank') {
      if (a instanceof HTMLAnchorElement && a.href) {
        await this.browserService.open({
          url: a.href.replace('capacitor://', 'https://'),
          target: this.target,
        });
      } else {
        await this.browserService.open({
          url: (a.parentElement as HTMLAnchorElement).href,
          target: this.target,
        });
      }
    }
  }
}
